export default __webpack_public_path__ + "a30bb47dad91aeb002eee32738006a7a.svg";